



























































































import { Component, Prop, Vue } from "vue-property-decorator";

import Inputseartch from "@/components/app/search/input-search.vue";
import WikiObjectCard from "@/components/tabs/wiki/wiki-object-card.vue";
import StandartModalHeader from "@/components/app/standart-modal-header.vue";
import WikiTableCard from "./wiki-table-card.vue";
import ChangeWiki from "./change-wiki.vue";

import { IWikiCategory, IWikiObject } from "@/@types/wiki/wiki-object";
import { IWikiType } from "@/@types/wiki/wiki_types";

interface ISortColumn {
  name: number;
  status: number;
}

@Component({
  components: {
    WikiObjectCard,
    Inputseartch,
    StandartModalHeader,
    WikiTableCard,
    ChangeWiki,
  },
})
class FullWikiList extends Vue {
  @Prop({ type: Array, default: () => [] }) short_wikis!: Array<IWikiObject>;
  @Prop({ type: Array, default: () => [] }) full_wikis!: Array<IWikiObject>;
  @Prop({ type: Boolean, default: false }) deleted!: boolean;
  @Prop({ type: String, default: "" }) category_id!: string;
  @Prop({ type: Array, default: () => [] }) categorys!: Array<IWikiCategory>;

  wiki_id = "";

  seartch = "";
  sortKey = "";
  sortOrder: ISortColumn = { name: 1, status: -1 };

  get subCategorys(): Array<IWikiCategory> {
    return this.categorys.filter((c) => {
      if (c.type == IWikiType.sub) return c;
    });
  }

  get wiki(): IWikiObject | null {
    const wiki = this.full_wikis.find((el) => el._id == this.wiki_id);
    return wiki ? wiki : null;
  }

  get wikis(): Array<IWikiObject> {
    const filterKey = this.seartch && this.seartch.toLowerCase();
    const order = this.sortOrder[this.sortKey as keyof ISortColumn] || 1;

    if (!this.category_id && !filterKey && !this.sortKey)
      return this.short_wikis;
    let wikiList: IWikiObject[] = this.full_wikis;

    if (this.category_id)
      return this.full_wikis.filter((wiki) => {
        if (wiki.category == this.category_id) return wiki;
      });

    if (filterKey)
      return this.full_wikis.filter((item) => {
        return (
          this.$getLocale(item.name)
            .toLowerCase()
            .indexOf(filterKey.toLowerCase()) > -1
        );
      });

    if (this.sortKey) {
      if (this.sortKey == "name") {
        wikiList = wikiList.slice().sort((a: IWikiObject, b: IWikiObject) => {
          const one = this.$getLocale(a.name);
          const two = this.$getLocale(b.name);
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }

      if (this.sortKey == "status") {
        wikiList = wikiList.slice().sort((a: IWikiObject, b: IWikiObject) => {
          const one = a.show;
          const two = b.show;
          return (one === two ? 0 : one > two ? 1 : -1) * order;
        });
      }
    }

    return wikiList;
  }

  change(data: Partial<IWikiObject>, id: string): void {
    this.$emit("changeWiki", data, id);
  }

  mustChange(id: string): void {
    if (!id) return;
    this.wiki_id = id;
    this.$nextTick(() => this.$bvModal.show("change-wiki"));
  }

  openWikiCard(id: string | undefined): void {
    if (!id) return;
    this.wiki_id = id;
    this.$nextTick(() => this.$bvModal.show("full-wiki-card"));
  }

  sortBy(key: string): void {
    this.sortKey = key;
    this.sortOrder[key as keyof ISortColumn] =
      this.sortOrder[key as keyof ISortColumn] * -1;
  }
}
export default FullWikiList;
